import financeiroApi from '../financeiroApi';

const PATH = '/api/v1/backend/fiscal/lc116';

export default {
  buscarLc116: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },

  pesquisarLcs: async (params) => {
        return financeiroApi.get(`${PATH}/pesquisar/lc`, { params });
  },
};
